<div class="login-container">
  <div class="logo"><img src="assets/images/BMW-logo.png" class="logo-img"/></div>
  <p class="top-title">{{title}}.</p>
  <div class="login-user" [hidden]="!isAuthenticated()">
    <a id="help" routerLink="/help">
      <img src="assets/images/icon-help-grey.png" class="logout-img"
        onmouseover="this.src='assets/images/icon-help.png';"
        onmouseout="this.src='assets/images/icon-help-grey.png';"/>
      </a>
    </div>
    <div class="login-user" [hidden]="!isAuthenticated()">
    <span class="" ngbTooltip="{{'' | i18n: 'logged-in-as'}}: {{user}}
      {{'' | i18n: 'user-dealer'}}: {{company}} ({{dealer}})
      {{'' | i18n: 'user-role'}}: {{role}}"
        tooltipClass="my-custom-class">
        <i class="fa fa-user-o" aria-hidden="true" style="color: #9c9c9c"></i>
      </span>
    </div>
    <div class="logout" [hidden]="!isAuthenticated()">
      <a id="logout" routerLink="/logout">
        <img src="assets/images/icon-logout-grey.png" routerLink="/logout" class="logout-img"
          onmouseover="this.src='assets/images/icon-logout-blue.png';"
          onmouseout="this.src='assets/images/icon-logout-grey.png';"/>
        </a>
      </div>
    </div>

    <div class="header-container" [hidden]="!isAuthenticated()">
      <div class="header-menu">
        <button id="home" routerLink="/dashboard" routerLinkActive="router-active"><img
        src="assets/images/icon-home-default.png" class="home-img"/></button>
        @if (isBEMarket()) {
          <button id="promotions" routerLink="/promotions"
          routerLinkActive="router-active">{{'' | i18n: 'menu-promotions'}}</button>
        }
        @if (isBEMarket()) {
          <button id="warranty-estimations" routerLink="/estimations"
          routerLinkActive="router-active">{{'' | i18n: 'menu-warranty-estimations'}}</button>
        }
        <button id="support-docs" routerLink="/support"
        routerLinkActive="router-active">{{'' | i18n: 'support-docs'}}</button>
        @if (showReport()) {
          <button id="reports" routerLink="/report" routerLinkActive="router-active">{{'' | i18n: 'reports'}}</button>
        }
        @if (isAuthenticated) {
          <app-messages-menu></app-messages-menu>
        }
        @if (isAdmin() && isBEMarket()) {
          <button id="admin" routerLink="/admin/promotions" routerLinkActive="router-active"
            style="right: 5%;position: absolute;">{{'' | i18n: 'administration'}}
          </button>
        }
        @if (isAdmin() && !isBEMarket()) {
          <button routerLink="/admin/config" routerLinkActive="router-active"
            style="right: 5%;position: absolute;">{{'' | i18n: 'administration'}}
          </button>
        }
      </div>
    </div>
